const { VITE_B2C_URL, VITE_API_GW_URL } = import.meta.env;

const conf = {
    b2cAppUrl: VITE_B2C_URL,
    apiRoot: VITE_API_GW_URL
};

export const Config = {
    get: (prop: keyof typeof conf) => conf[prop]!
};
